import { render } from "./ViewPublicationPost.vue.js?vue&type=template&id=fce26964!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationPost.vue?vue&type=template&id=fce26964"
import script from "./ViewPublicationPost.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationPost.vue?vue&type=script&lang=js"
export * from "./ViewPublicationPost.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/ViewPublicationPost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fce26964"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fce26964', __exports__)) {
    api.reload('fce26964', __exports__)
  }
  
  module.hot.accept("./ViewPublicationPost.vue.js?vue&type=template&id=fce26964!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationPost.vue?vue&type=template&id=fce26964", () => {
    api.rerender('fce26964', render)
  })

}


export default __exports__